export default __webpack_public_path__ + "static/media/topup.d298ab23.svg";